__webpack_require__.p = "/production/spa/ui/public/";